export const LEAD_AGE_DAY_OPTIONS = [1, 3, 7, 14, 30, 60, 90];

export const DEFAULT_LEAD_AGE_RESTRICTION = {
  enabled: false,
  minDays: 14,
};

export const normalizeLeadAgeRestriction = (value) => {
  if (!value || typeof value !== "object") {
    return { ...DEFAULT_LEAD_AGE_RESTRICTION };
  }

  const minDays = Number(value.minDays);
  const normalizedMinDays = LEAD_AGE_DAY_OPTIONS.includes(minDays)
    ? minDays
    : DEFAULT_LEAD_AGE_RESTRICTION.minDays;

  return {
    enabled: Boolean(value.enabled),
    minDays: normalizedMinDays,
  };
};

export const appendLeadAgeRestrictionToSql = (query, leadAgeRestriction) => {
  if (!query) return query;

  const restriction = normalizeLeadAgeRestriction(leadAgeRestriction);
  if (!restriction.enabled) return query;

  return `${query}  AND l.[Date] <= DATEADD(day, -${restriction.minDays}, GETDATE())\n`;
};
